import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export type PlateSetupGenerateRequest = {
  panelId?: number | null;
  runName?: string | null;
  mappingTypeId?: string | null;
  plateTypeId: string;
  noOfAccessionsInOnePlate: string;
  outputTemplate?: string | null;
  createdBy?: string | null;
};

export type PlateSetupWellResponse = {
  plateSetupDetailId: number;
  plateSetupId?: number | null;
  wellPosition?: string | null;
  wellName?: string | null;
  accessionPlaceholder?: string | null;
  assignTestJson?: string | null;
};

export type PlateSetupStructureResponse = {
  plateSetupId: number;
  plateTypeId?: string | null;
  mappingTypeId?: string | null;
  panelId?: number | null;
  noOfAccessionsInOnePlate?: string | null;
  rowCount: number;
  columnCount: number;
  totalWells: number;
  rows: string[];
  columns: number[];
  wells: PlateSetupWellResponse[];
};

export type PlateSetupListResponse = {
  plateSetupId: number;
  labId?: number | null;
  panelId?: number | null;
  panelName?: string | null;
  runName?: string | null;
  mappingTypeId?: string | null;
  plateTypeId?: string | null;
  noOfAccessionId?: string | null;
  outputTemplate?: string | null;
  createdBy?: string | null;
  createdDate?: string | null;
  rowCount: number;
  columnCount: number;
  totalWells: number;
  rows: string[];
  columns: number[];
  wells: PlateSetupWellResponse[];
};

type PlateSetupLookupOption = {
  value: string;
  label: string;
};

type PlateSetupLookupsResponse = {
  PlateType: PlateSetupLookupOption[];
  MappingType: PlateSetupLookupOption[];
  Panel: PlateSetupLookupOption[];
};

const GeneratePlateSetupStructure = (payload: PlateSetupGenerateRequest) => {
  return HttpClient().post<PlateSetupStructureResponse>(
    `/${apiRoutes.InfectiousDisease.GeneratePlateSetupStructure}`,
    payload
  );
};

const GetPlateSetupLookups = () => {
  return HttpClient().get<PlateSetupLookupsResponse>(
    `/${apiRoutes.InfectiousDisease.GetPlateSetupLookups}`
  );
};

export type PlateSetupQueryModel = {
  runName?: string | null;
  panelId?: number | null;
  outputTemplate?: string | null;
  mappingTypeId?: string | null;
  plateTypeId?: string | null;
  noOfAccessionId?: string | null;
};

export type PlateSetupSearchRequest = {
  pageNumber: number;
  pageSize: number;
  sortColumn?: string | null;
  sortDirection?: string | null;
  queryModel: PlateSetupQueryModel;
};

export type PlateSetupPagedResponse = {
  statusCode: number;
  total: number;
  data: PlateSetupListResponse[];
};

const SearchPlateSetups = (payload: PlateSetupSearchRequest) => {
  return HttpClient().post<PlateSetupPagedResponse>(
    `/${apiRoutes.InfectiousDisease.SearchPlateSetups}`,
    payload
  );
};

export type PlateSetupTestControlOption = {
  value: string;
  label: string;
  typeOfTest: string;
  isControl: boolean;
};

const GetTestControlLookups = (panelId: number) => {
  return HttpClient().get<PlateSetupTestControlOption[]>(
    `/${apiRoutes.InfectiousDisease.GetPlateSetupTestControlLookups}/${panelId}`
  );
};

export type UpdatePlateSetupWellAssignmentRequest = {
  plateSetupDetailId: number;
  assignTestJson: string | null;
};

export type UpdatePlateSetupStructureRequest = {
  plateSetupId: number;
  wells: UpdatePlateSetupWellAssignmentRequest[];
};

export type RequestResponse<T> = {
  statusCode: number;
  message: string;
  data: T;
};

const UpdateStructureAssignments = (
  payload: UpdatePlateSetupStructureRequest
) => {
  return HttpClient().put<RequestResponse<boolean>>(
    `/${apiRoutes.InfectiousDisease.UpdatePlateSetupStructureAssignments}`,
    payload
  );
};

const DeletePlateSetup = (plateSetupId: number) => {
  return HttpClient().delete<RequestResponse<boolean>>(
    `/${apiRoutes.InfectiousDisease.DeletePlateSetup}/${plateSetupId}`
  );
};

const PlateSetupService = {
  GeneratePlateSetupStructure,
  GetPlateSetupLookups,
  SearchPlateSetups,
  GetTestControlLookups,
  UpdateStructureAssignments,
  DeletePlateSetup,
};

export default PlateSetupService;
